import { render } from "./AppVideoPlayer.vue?vue&type=template&id=2ad611fc&scoped=true"
import script from "./AppVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AppVideoPlayer.vue?vue&type=script&lang=js"

import "./AppVideoPlayer.vue?vue&type=style&index=0&id=2ad611fc&lang=scss&scoped=true"
import "./AppVideoPlayer.vue?vue&type=style&index=1&id=2ad611fc&lang=scss"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad611fc"]])

export default __exports__